import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { QuicklinkModule } from 'ngx-quicklink';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../rollbar_config';
import { ClientsComponent } from './clients/clients.component';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
	declarations: [AppComponent],
	imports: [BrowserModule, CoreModule, QuicklinkModule, BrowserAnimationsModule],
	providers: [
		{ provide: ErrorHandler, useClass: RollbarErrorHandler },
		{ provide: RollbarService, useFactory: rollbarFactory },
		provideClientHydration(),
	],
    bootstrap: [AppComponent]
})
export class AppModule {}
